// import { useEffect, useState } from "react";
// import { ScheduleDisplay } from "./scheduleDisplay";
// import { RoundedTab, RoundedTabGroup } from "./roundedAnalytics";
// import { SummaryDisplay } from "./summaryDisplay";
// import { useIntl } from "react-intl";
// import { UserView } from "./userViewAnaly/userView";
// // import { CourseView } from "./courseView";
// import { CourseViewDup } from "./courseViewDup";
// import { CourseViewDuplicate } from "./courseViewDuplicate";

// export interface AnalyticsProps {}
// export function Analytics(props: AnalyticsProps) {
//   function resetTabs(tabName: string) {}

//   // function getSummarySchedules() {
//   // let api=ApiServices.getInstance();
//   // api.makeRequest(`f9afa76e-04d1-48dc-b5c8-69471c5f3de5/analytics/summarySchedules?fromtime=${1698818388137}&tilltime=${1698991188132}`,"GET").then((data)=>{
//   //     console.log("data",data)
//   //     // setSummarySchedules(data)
//   //     // setSummarySchedules(data)
//   // })
//   // api.makeRequest(`f9afa76e-04d1-48dc-b5c8-69471c5f3de5/analytics/summarySchedules?fromtime=${1698818388137}&tilltime=${1698991188132}`,"GET").then((data)=>{
//   //     const response=data.resources.map((ele:))
//   // })
//   // }

//   // useEffect(() => {
//   //   console.log("inside use effect of get summary schedules")
//   //   getSummarySchedules();
//   //   // resetTabs()
//   // }, []);

//   console.log("schedule name");
//   const intl = useIntl();
//   return (
//     <div>
//       <div className="w-full">
//         <RoundedTabGroup
//           className="w-full flex flex-col items-start"
//           defaultTabName="users"
//           onClick={resetTabs}
//         >

//           <RoundedTab
//             name="users"
//             title={intl.formatMessage({ id: "analytics.tabName.users" })}
//           >
//             {
//               <div>
//                 <UserView />
//               </div>
//             }
//           </RoundedTab>

//           <RoundedTab
//             name="course"
//             title={intl.formatMessage({ id: "analytics.tabName.courses" })}
//           >
//             {
//               <div className="pb-[20%]">
//                 {/* <CourseView /> */}
//                 {/* <CourseViewDup /> */}
//                 <CourseViewDuplicate />
//               </div>
//             }
//           </RoundedTab>
//         </RoundedTabGroup>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { ScheduleDisplay } from "./scheduleDisplay";
import { RoundedTab, RoundedTabGroup } from "./roundedAnalytics";
import { SummaryDisplay } from "./summaryDisplay";
import { useIntl } from "react-intl";
import { UserView } from "./userViewAnaly/userView";
// import { CourseView } from "./courseView";
import { CourseViewDup } from "./courseViewDup";
import { CourseViewDuplicate } from "./courseViewDuplicate";
import ApiServices from "../../service/apiService";

export interface AnalyticsProps {}

export function Analytics(props: AnalyticsProps) {
  const intl = useIntl();

  const [summarySchedules, setSummarySchedules] = useState<any>(null);

  function resetTabs(tabName: string) {
    // handle tab reset logic here
  }

  function getSummarySchedules() {
    let api = ApiServices.getInstance();
    api
      .makeRequest(
        `f9afa76e-04d1-48dc-b5c8-69471c5f3de5/analytics/summarySchedules?fromtime=${1698818388137}&tilltime=${1698991188132}`,
        "GET"
      )
      .then((data) => {
        console.log("data", data);
        setSummarySchedules(data);
      });
  }

  useEffect(() => {
    getSummarySchedules();
  }, []);

  return (
    <div>
      <div className="w-full">
        <RoundedTabGroup
          className="w-full flex flex-col items-end"
          defaultTabName="summary"
          onClick={resetTabs}
        >
          <RoundedTab
            name="summary"
            title={intl.formatMessage({ id: "analytics.tabName.summary" })}
          >
            <div className="pb-[20%]">
              <SummaryDisplay />
            </div>
          </RoundedTab>

          <RoundedTab
            name="schedule"
            title={intl.formatMessage({ id: "analytics.tabName.schedule" })}
          >
            <div className="pb-[20%]">
              <ScheduleDisplay />
            </div>
          </RoundedTab>


          <RoundedTab
            name="users"
            title={intl.formatMessage({ id: "analytics.tabName.users" })}
          >
            <div className="pb-[20%]">
              <UserView />
            </div>
          </RoundedTab>

          <RoundedTab
            name="course"
            title={intl.formatMessage({ id: "analytics.tabName.courses" })}
          >
            <div className="pb-[20%]">
              {/* <CourseView /> */}
              {/* <CourseViewDup /> */}
              <CourseViewDuplicate />
            </div>
          </RoundedTab>
        </RoundedTabGroup>
      </div>
    </div>
  );
}
